import { client } from 'shared';

export function makeInstantBooking(bookingId: number, sendToOthers: boolean = false) {
    return client('api/instant-booking/' + bookingId + '/book/', {
        method: 'POST',
        body: { send_to_others: sendToOthers },
    });
}
